import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/company', name: 'WaWeb', component: () => import('../components/company')},
    {path: '*', name: '404', component: () => import('../components/404')}
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js